<p-calendar *ngIf="events" [ngClass]="selectionMode" class="custom-calendar" [formControl]="form"
    [inline]="inline" [selectionMode]="selectionMode" (onSelect)="select($event)"
    (onClearClick)="clearClick($event)" [dateFormat]="format" [selectOtherMonths]="true" [showIcon]="true"
    [minDate]="minDate" [maxDate]="maxDate" [icon]="'icon icon-24-px-calendario'"
    [readonlyInput]="true" [appendTo]="appendTo || null " [yearNavigator]="true" yearRange="2000:2030"
    [showButtonBar]="showButtonBar" #calendarRef>
    <ng-template pTemplate="date" let-date>
        {{date.day}}
        <div class="inline-bullets">
            <div class="row">
                <div class="col-4 p-0" *ngFor="let severity of matchDate(date)">
                    <div class="bullet" [ngClass]="{'danger' : severity === 'HIGH', 'warn': severity === 'MEDIUM',
                'success': severity === 'LOW'}"></div>
                </div>
            </div>
        </div>
    </ng-template>
</p-calendar>

<mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="calendarRef"></mapfre-auditlib-form-errors>